import { IconButton, styled, Theme } from "@mui/material";
import { IStyledIconButtonProps } from "./types";

const pickColor = (theme?: Theme) => ({
    primary: (theme as any).palette?.primary?.darker,
    secondary: (theme as any).palette?.secondary?.main,
    tertiary: (theme as any).palette?.tertiary?.main,
    neutral: (theme as any).palette?.neutral?.lightest,
    accentInfo: (theme as any).palette?.accentInfo?.main,
    accentSuccess: (theme as any).palette?.accentSuccess?.main,
    accentWarning: (theme as any).palette?.accentWarning?.main,
    accentError: (theme as any).palette?.accentError?.main,
})

const StyledIconButton = styled(IconButton,{
    shouldForwardProp: prop => !["customPosition", "customVariant", "customColor"].includes(prop.toString())
})<IStyledIconButtonProps>(({ theme, customPosition, customVariant, customColor = "primary" }) => {
    // basic visual styles
    const baseStyles = {
        backgroundColor: `${customVariant === 'filled' ? (theme as any).palette?.primary?.darker : 'transparent'}`,
        borderRadius: `${customVariant === 'filled' ? (theme as any).shape?.border?.button?.radius?.[2] : '50%'}`,
        padding: `${customVariant === "clean" ? "0px" : theme.spacing(1)}`,
        "& .MuiSvgIcon-root":{
            color: `${customVariant === 'filled' ? (theme as any).palette.neutral.lighter : pickColor(theme)[customColor]} !important`,
        },
        "&:hover":{
            backgroundColor: `${customVariant === 'filled' ? (theme as any).palette?.neutral?.lighter : 'transparent'}`,
            "& .MuiSvgIcon-root":{
            color: `${customVariant === 'filled' ? (theme as any).palette.primary.darker : pickColor(theme)[customColor]} !important`,
        },
        },
        '&.Mui-disabled':{
            border: `1px solid ${(theme as any).palette.neutral.dark}`,
            color: `${(theme as any).palette.neutral.dark} !important`
        }
    } as any;

    // positioning logic: absolute relative to parent.
    // small offset (8px) from the edges to avoid sticking flush; change if needed.
    const offset = 8;
    const positionStyles: Record<string, any> = {};

    if (customPosition) {
        positionStyles.position = 'absolute';
        switch (customPosition) {
            case 'top-left':
                positionStyles.top = offset;
                positionStyles.left = offset;
                break;
            case 'top-right':
                positionStyles.top = offset;
                positionStyles.right = offset;
                break;
            case 'bottom-left':
                positionStyles.bottom = offset;
                positionStyles.left = offset;
                break;
            case 'bottom-right':
                positionStyles.bottom = offset;
                positionStyles.right = offset;
                break;
            default:
                break;
        }
    }

    return {
        ...baseStyles,
        ...positionStyles
    };
});

export { StyledIconButton }